if(!customElements.get('ls-expo-carousel'))customElements.define('ls-expo-carousel',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.controller=new AbortController();const opts={signal:this.controller.signal};
this.slides=[...this.querySelectorAll('[data-expo-slide]')];this.tabs=[...this.querySelectorAll('[data-slide]')];this.pause=this.querySelector('[data-pause]');this.index=0;
this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.playing=!this.motion.matches;this.focused=false;
this.tabs.forEach((b,i)=>b.addEventListener('click',()=>{this.show(i);this.sync()},opts));
this.pause.addEventListener('click',()=>{this.playing=!this.playing;this.sync()},opts);
this.addEventListener('focusin',e=>{this.focused=!!e.target.closest('[data-expo-slide]');this.sync()},opts);
this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=!!this.querySelector('[data-expo-slide]:focus-within');this.sync()})},opts);
document.addEventListener('visibilitychange',()=>this.sync(),opts);
this.motion.addEventListener('change',()=>{this.playing=!this.motion.matches;this.sync()},opts);
this.show(0,false);this.sync();
}
show(i,animate=true){
const previous=this.index;this.animations?.forEach(a=>a.cancel());this.animations=[];
this.index=i;
this.slides.forEach((s,n)=>{s.hidden=n!==i;s.inert=n!==i;s.setAttribute('aria-hidden',String(n!==i));});
this.tabs.forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));
if(animate&&previous!==i&&!this.motion.matches){
const outgoing=this.slides[previous],incoming=this.slides[i];outgoing.hidden=false;
const options={duration:650,easing:'cubic-bezier(.22,.61,.36,1)'};
const a=outgoing.animate([{transform:'translateX(0)'},{transform:'translateX(-100%)'}],options);
const b=incoming.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}],options);
a.onfinish=()=>{outgoing.hidden=true;};this.animations=[a,b];
}
}
sync(){clearInterval(this.timer);this.pause.textContent=this.playing?'Ⅱ':'▶';this.pause.setAttribute('aria-label',this.playing?this.pause.dataset.pauseLabel:this.pause.dataset.playLabel);if(this.playing&&!this.focused&&!document.hidden)this.timer=setInterval(()=>this.show((this.index+1)%this.slides.length),6000);}
disconnectedCallback(){this.animations?.forEach(a=>a.cancel());clearInterval(this.timer);this.controller?.abort();this.ready=false;}
});